"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _box = _interopRequireDefault(require("./box"));

var _excluded = ["className", "data-test-id", "html", "onClick", "sanitize", "tag"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /**  Font size css style system prop */
  className: _propTypes.string,

  /** test id for selecting this element in Cypress */
  "data-test-id": _propTypes.string,

  /**  Margin css style system prop */
  html: _propTypes.string,

  /** Padding css style system prop  */
  onClick: _propTypes.func,

  /** sanitize boolean prop */
  sanitize: _propTypes.bool,

  /** Polymorphic prop that determines what's ultimately being rendered  */
  tag: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.node, _propTypes.func, _propTypes.string])
};

var RawHtml = function RawHtml(_ref) {
  var className = _ref.className,
      dataTestId = _ref["data-test-id"],
      html = _ref.html,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? null : _ref$onClick,
      sanitize = _ref.sanitize,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "div" : _ref$tag,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_box["default"], _extends({
    as: tag,
    className: className,
    dangerouslySetInnerHTML: {
      __html: html
    },
    "data-test-id": dataTestId,
    onClick: onClick,
    sanitize: sanitize
  }, props));
};

RawHtml.propTypes = propTypes;
RawHtml.displayName = "Primitives.RawHtml";
var _default = RawHtml;
exports["default"] = _default;